var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.s.container }, [
    _c("div", { style: _vm.s.wrapper }, [
      _c("div", { style: _vm.s.title }, [
        _vm._v(_vm._s(_vm.Title)),
        _c("span", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ShowClose,
              expression: "ShowClose"
            }
          ],
          style: _vm.s.close,
          on: { click: _vm.close }
        })
      ]),
      _c("div", { staticClass: "head" }, [
        _vm._v(_vm._s(_vm.$t("assets.vb.connect.tips")))
      ]),
      _c(
        "div",
        { style: _vm.s.body },
        [
          _c("qrcode", {
            staticClass: "code_container",
            attrs: { options: _vm.qrcodeOpt, text: _vm.vb && _vm.vb.uri }
          })
        ],
        1
      ),
      _vm.ShowBottom
        ? _c("div", { style: _vm.s.btnGroup }, [
            !!_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.STxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  { style: [_vm.s.lBtn, _vm.s.btn], on: { click: _vm.lClick } },
                  [_vm._v(_vm._s(_vm.LTxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.RTxt))]
                )
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }